import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ChatList from '../components/Chat/ChatList';
import ChatWindow from '../components/Chat/ChatWindow';
import api from '../services/api';

// Obtener la URL base de la API de las variables de entorno
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

const ChatPage = () => {
  const { userId } = useParams(); // ID del usuario con quien chatear
  const navigate = useNavigate();
  const { currentUser, loading: authLoading } = useAuth();
  const [otherUser, setOtherUser] = useState(null);
  const [loading, setLoading] = useState(true);
  
  // Si se proporciona un userId, obtener información de ese usuario
  useEffect(() => {
    if (!userId || !currentUser || authLoading) return;
    
    const fetchOtherUser = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_URL}/users/${userId}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        
        if (response.ok) {
          const userData = await response.json();
          setOtherUser(userData);
        }
      } catch (error) {
        console.error('Error al obtener información del usuario:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchOtherUser();
  }, [userId, currentUser, authLoading]);
  
  // Si está cargando la autenticación o los datos del usuario
  if (authLoading || loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '70vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
      </div>
    );
  }
  
  // Si no hay usuario autenticado, redirigir al login
  if (!currentUser) {
    return <Navigate to="/login" />;
  }
  
  return (
    <div className="chat-page">
      <div className="chat-container">
        <div className="chat-sidebar">
          <ChatList currentUser={currentUser} />
        </div>
        
        <div className="chat-main">
          {otherUser ? (
            <ChatWindow currentUser={currentUser} otherUser={otherUser} />
          ) : (
            <div className="no-chat-selected">
              <p>Selecciona una conversación para comenzar a chatear</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatPage;
